import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCSVReportLoading, getMapData } from '../selectors';
import { clearReport, setMapDataLoading } from '../actions';
import Map from '../../../map/Map/updatedMap';
import ErrorBoundary from '../../../common/ErrorBoundary';
// import debounce from 'lodash/debounce';

function PreviewTable({ loading, mapData, filters, loadData, mapFilters }) {
    const [map, setMap] = React.useState(null);
    // const [time, setTime] = React.useState(null);
    // React.useEffect(() => {
    //     if (map) {
    //         onZoomChange();
    //     }
    // }, [map]);

    // React.useEffect(() => {
    //     onZoomChange();
    // }, [mapFilters]);
    let currentlyQueriedZoom = 1;
    const debounceZoomChange = () => {
        if (map.getZoom() - currentlyQueriedZoom > 7) {
            currentlyQueriedZoom = map.getZoom();
            setTimeout(() => {
                const bounds =
                    map.getBounds() || new window.google.maps.LatLngBounds();
                loadData({
                    zoom: map.getZoom(),
                    dimensions: {
                        top: bounds.getNorthEast().lat(),
                        right: bounds.getNorthEast().lng(),
                        bottom: bounds.getSouthWest().lat(),
                        left: bounds.getSouthWest().lng(),
                    },
                    ...filters,
                    ...mapFilters.filter,
                });
            }, 10);
        }
    };

    const onZoomChange = () => {
        if (map) {
            // debounce(() => debounceZoomChange(), 500);
            debounceZoomChange();
        }
    };
    const onLoad = React.useCallback((map) => setMap(map), []);
    return (
        <div className="col-md-12">
            <div className="content-box card">
                <div className="col pl-2">
                    <h2 className="mb-24">Map View</h2>
                </div>
                <ErrorBoundary>
                    <label className="alert-text">
                        {loading && 'Loading...'}
                    </label>
                    <Map
                        dataPoints={mapData}
                        map={map}
                        minZoom={1}
                        maxZoom={13}
                        onZoomChanged={onZoomChange}
                        onDragEnd={onZoomChange}
                        onLoad={onLoad}
                    />
                </ErrorBoundary>
            </div>{' '}
        </div>
    );
}

PreviewTable.propTypes = {
    loading: PropTypes.bool.isRequired,
    mapData: PropTypes.array,
    filters: PropTypes.object,
    loadData: PropTypes.func,
    mapFilters: PropTypes.object,
};

PreviewTable.defaultProps = {
    loading: false,
    filters: {},
    mapFilters: {},
};

const mapStateToProps = (state) => {
    return {
        loading: getCSVReportLoading(state),
        mapData: getMapData(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: (userInput) => dispatch(setMapDataLoading(userInput)),
        closeReport: () => dispatch(clearReport()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewTable);
